import { Category } from 'models/category'

export const CategoriesResolver = {
    categories: () =>
        [
            {
                name: 'Doors',
                description:
                    'The Doors were an American rock band formed in Los Angeles in 1965',
                listings: [
                    {
                        name: 'Basic Listing',
                        totalListing: 200,
                    },
                    {
                        name: 'Enhanced Listing',
                        totalListing: 25,
                    },
                    {
                        name: 'Premium Listing',
                        totalListing: 5,
                    },
                    {
                        name: 'Upgrade Listing',
                        totalListing: 225,
                    },
                ],
            },
            {
                name: 'Windows',
                description:
                    'An opening in the wall or roof of a building or vehicle that is fitted with glass or other transparent items.',
                listings: [
                    {
                        name: 'Basic Listing',
                        totalListing: 50,
                    },
                    {
                        name: 'Enhanced Listing',
                        totalListing: 5,
                    },
                    {
                        name: 'Upgrade Listing',
                        totalListing: 55,
                    },
                ],
            },
            {
                name: 'Pipes',
                description:
                    'A tube of metal, plastic, or other material used to convey water, gas, oil, or other fluid substances.',
                listings: [
                    {
                        name: 'Basic Listing',
                        totalListing: 168,
                    },
                    {
                        name: 'Upgrade Listing',
                        totalListing: 168,
                    },
                ],
            },
            {
                name: 'Floors',
                description:
                    'The lower surface of a room, on which one may walk.',
                listings: [
                    {
                        name: 'Basic Listing',
                        totalListing: 67,
                    },
                    {
                        name: 'Enhanced Listing',
                        totalListing: 15,
                    },
                    {
                        name: 'Premium Listing',
                        totalListing: 8,
                    },
                    {
                        name: 'Upgrade Listing',
                        totalListing: 82,
                    },
                ],
            },
            {
                name: 'Curtain Panels',
                description: 'Blocks the sun',
                listings: [
                    {
                        name: 'Basic Listing',
                        totalListing: 1,
                    },
                    {
                        name: 'Enhanced Listing',
                        totalListing: 4,
                    },
                    {
                        name: 'Premium Listing',
                        totalListing: 0,
                    },
                    {
                        name: 'Upgrade Listing',
                        totalListing: 1,
                    },
                ],
            },
            {
                name: 'Air Panels',
                description: 'Blocks the air',
                listings: [
                    {
                        name: 'Premium Listing',
                        totalListing: 11,
                    },
                ],
            },
            {
                name: 'Roofs',
                description: 'Protects the house from the sun',
                listings: [
                    {
                        name: 'Basic Listing',
                        totalListing: 11,
                    },
                    {
                        name: 'Enhanced Listing',
                        totalListing: 34,
                    },
                    {
                        name: 'Premium Listing',
                        totalListing: 20,
                    },
                    {
                        name: 'Upgrade Listing',
                        totalListing: 11,
                    },
                ],
            },
            {
                name: 'Chimney Pot',
                description: 'Puff puff the smoke comes out',
                listings: [
                    {
                        name: 'Premium Listing',
                        totalListing: 11,
                    },
                ],
            },
            {
                name: 'Ridge',
                description: 'Center of roof covering',
                listings: [
                    {
                        name: 'Premium Listing',
                        totalListing: 1234,
                    },
                ],
            },
            {
                name: 'Brick',
                description: 'Protects the house from the environment',
                listings: [
                    {
                        name: 'Basic Listing',
                        totalListing: 11,
                    },
                    {
                        name: 'Enhanced Listing',
                        totalListing: 34,
                    },
                    {
                        name: 'Premium Listing',
                        totalListing: 20,
                    },
                ],
            },
        ] as Category[],
}
